module.exports = __webpack_public_path__ + "static/media/edit-icon.a4130300.svg";